import BnbChainLogo from './BnbChainLogo'

export default BnbChainLogo
